export enum MarkerIconSvgSelected {
  hotel = 'cdn/icons/hotelSelected.svg',
  destination = 'cdn/icons/destinationSelected.svg',
  favorite = 'cdn/icons/favoriteSelected.svg',
  airport = 'cdn/icons/airportSelected.svg',
  railway = 'cdn/icons/railwaySelected.svg',
  port = 'cdn/icons/portSelected.svg',
  hotelLocation = 'cdn/icons/hotelLocationSelected.svg',
}
